//// Application Configuration

//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components

//// Carbon Components
import { FileUploaderItem } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const customFileUploaderItem = ({ name, status, handleFileDelete }) => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <FileUploaderItem
                errorBody="You have exceeded the maximum file size. Select a new file, remove files, and try again."
                errorSubject="File size exceeds limit"
                iconDescription="Delete file"
                invalid={false}
                uuid={name}
                name={name}
                status={status}
                size="md"
                onDelete={(e, { uuid }) => handleFileDelete(e, uuid)}
            />
        </>
    )
}

export default customFileUploaderItem
